import Api from './api.service';

const ENDPOINT = '/terms';

export default {
  getTerm: () => Api.get(`${ENDPOINT}?user_type=1`),
  acceptTerm: (id, data) => Api.patch(`lawyers/${id}/accept-term`, data),
};
